import React from 'react';
import { useAuth } from '../context/AuthContext';

/**
 * Entitlement wall for a route tree. Assumes it sits inside ProtectedRoute,
 * so auth is already resolved. The page still renders (the user is signed
 * in), but when the account lacks any of the ACCESS_ROLES (see
 * config/access.js) `fallback` is layered on top as a blocking overlay — the
 * sidenav stays visible so the account/logout control keeps working (SideNav
 * and BottomNav disable their other buttons via the same `hasAccess` check).
 */
const RoleGate = ({ fallback = null, children }) => {
  const { hasAccess, isLoading } = useAuth();

  if (isLoading) return null;

  return (
    <>
      {children}
      {!hasAccess() && fallback}
    </>
  );
};

export default RoleGate;
